function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { HeroTertiary, Div, Spinner, Button } from '@cbhq/cdx-components';
import { useContentfulMicrocopy } from '../../globals/microcopy.js';
import { getEntryProps } from '../../utils/getEntryProps.js';
import { PageTemplateLayout } from '../PageTemplateLayout.js';
import { PageTemplateProviders } from '../PageTemplateProviders.js';
import { ListingWayfinding } from './ListingWayfinding.js';
import { NoResults } from './NoResults.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
const LISTING_TEMPLATE_CONTENT_MODEL_ID = 'cdxTemplateListingPage';
/**
 * This template expects that you provide a loading and sorting method depending on the listing method. Not providing, will only render as a static wayfinding listing the articles provided.
 */
function ListingTemplateContent({
  title,
  projectSettings,
  listingType,
  noSearchResultsText,
  noSearchResultsLink,
  siteConfig,
  articles,
  isLoading,
  canLoadMore,
  onLoadMore,
  onSort,
  totalCount,
  searchTerm,
  path,
  onSearch,
  templateWidth,
  applicationSettingsExtraProps
}) {
  const microcopies = useContentfulMicrocopy();
  const _getEntryProps = getEntryProps(projectSettings),
    fallbackImage = _getEntryProps.fallbackImage;
  const fallbackImageUrl = fallbackImage?.fields.file.url;
  const fallbackImageAlt = fallbackImage?.fields.title;
  const _useState = useState('asc'),
    _useState2 = _slicedToArray(_useState, 2),
    sortValue = _useState2[0],
    setSortValue = _useState2[1];

  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
  const handleSort = nextSort => {
    setSortValue(nextSort);
    if (onSort) onSort(nextSort);
  };
  const isSearch = listingType === 'search';
  return /*#__PURE__*/jsxs(PageTemplateLayout, {
    siteConfig: siteConfig,
    projectConfig: projectSettings,
    path: path,
    templateWidth: templateWidth,
    onSearch: onSearch,
    applicationSettingsExtraProps: applicationSettingsExtraProps,
    children: [/*#__PURE__*/jsx(HeroTertiary, {
      pre: isSearch && searchTerm ? microcopies.global?.resultsFor : undefined,
      headline: isSearch && searchTerm ? searchTerm : title || '',
      sortValue: sortValue,
      setSortValue: onSort ? handleSort : undefined,
      articlesTotalCount: totalCount
    }), isLoading && /*#__PURE__*/jsx(Div, {
      position: "fixed",
      zIndex: 1,
      bottom: 16,
      right: 16,
      children: /*#__PURE__*/jsx(Spinner, {
        size: 2,
        color: "primary"
      })
    }), /*#__PURE__*/jsxs(Div, {
      flexDirection: "column",
      children: [/*#__PURE__*/jsx(ListingWayfinding, {
        articles: articles,
        fallbackImageUrl: fallbackImageUrl,
        fallbackImageAlt: fallbackImageAlt
      }), isSearch && articles?.length < 1 && /*#__PURE__*/jsx(Fragment, {
        children: isLoading ? /*#__PURE__*/jsx(Div, {
          flex: 1,
          spacingHorizontal: 5,
          alignItems: "center",
          justifyContent: "center",
          children: /*#__PURE__*/jsx(Spinner, {
            size: 4,
            color: "primary"
          })
        }) : /*#__PURE__*/jsx(NoResults, {
          onSearch: onSearch,
          searchTerms: projectSettings?.fields.suggestedSearchTerms,
          noSearchResultsText: noSearchResultsText,
          goBackLink: noSearchResultsLink
        })
      }), canLoadMore && onLoadMore && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx(Div, {
          justifyContent: "center",
          flex: 1,
          spacingTop: 5,
          children: /*#__PURE__*/jsx(Button, {
            onPress: () => onLoadMore(),
            disabled: isLoading,
            children: microcopies.global?.showMore
          })
        })
      })]
    })]
  });
}
function ListingTemplate(props) {
  return /*#__PURE__*/jsx(PageTemplateProviders, {
    siteConfig: props.siteConfig,
    componentMap: props.componentMap,
    cdsPalette: props.cdsPalette,
    cdsThemeMode: props.cdsThemeMode,
    children: /*#__PURE__*/jsx(ListingTemplateContent, _objectSpread({}, props))
  });
}
export { LISTING_TEMPLATE_CONTENT_MODEL_ID, ListingTemplate };
//# sourceMappingURL=ListingTemplate.js.map
